import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
    selector: 'emt-basic-text-input',
    templateUrl: './basic-text-input.component.html',
    styleUrls: ['./basic-text-input.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        NgClass,
        FormsModule,
        ReactiveFormsModule,
    ],
})
export class BasicTextInputComponent implements OnInit {
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() type?: string;
  @Input() control: FormControl;
  @Input() disabled: boolean;
  @Input() maxlength?: number;

  constructor() {}

  ngOnInit() {}
}
